import React, { useState, useEffect } from 'react';
import { ContentBox } from '../ContentBox';
import { SingleInput, SingleRedio, SingleText } from '../../Res/BaseInput';
import { SubmitButton } from '../../Res/BaseButton';
import { RespResumeOtherDataFamilyList, RespResumeOtherData, RespResumeOtherDataEducationList } from '../../../../item/ItemResume';
import { api_addResumeOtherData } from '../../../../api/apiResume';
import Swal from 'sweetalert2';
import { getItemsInfo } from '../../../../item/ItemTools';

export const OtherData_education = "education"
export function ContractorResumeEducation({ rId, education, companyId, setIsLoading, isEdit, isEmployee = false }) {
    const [resumeId, setResumeId] = useState("")
    const [mEducation, setEducations] = useState({})

    const [mEducationList, setEducationList] = useState([])


    useEffect(() => {
        if (rId !== undefined && rId !== "" && rId !== resumeId) {
            setResumeId(rId)
            //console.log(rId)
            //getResumeOtherData(rId)
        }
    }, [rId])

    useEffect(() => {
        if (education !== undefined && education !== mEducation && Object.keys(education).length !== 0) {
            //console.log(education)
            setEducations(education)
            var mRespResumeOtherDataEducationList = new RespResumeOtherDataEducationList({})
            mRespResumeOtherDataEducationList.fromJson(education.resumeData)
            //console.log(mRespResumeOtherDataEducationList)
            setEducationList(mRespResumeOtherDataEducationList.educationList)
        }
    }, [education])

    function setEducation(index, family) {
        mEducationList[index] = family
        setEducationList(mEducationList)
    }

    /*
    function getResumeOtherData(resumeId) {
        var mReqResumeOtherData = new ReqResumeOtherData({
            resumeId,
            resumeKey: OtherData_education
        })
        //console.log(mReqResumeOtherData)
        api_getResumeOtherData({
            mReqResumeOtherData,
            success: (jsonData) => {
                //console.log(jsonData.info.resumeData)
                var mRespResumeOtherDataEducationList = new RespResumeOtherDataEducationList({})
                mRespResumeOtherDataEducationList.fromJson(jsonData.info.resumeData)
                //console.log(mRespResumeOtherDataEducationList)
                setEducationList(mRespResumeOtherDataEducationList.educationList)
                setIsLoading(false)
            },
            failure: (err) => {
                setIsLoading(false)
            }
        })
    }
    */

    async function saveOtherDataFamily() {
        //console.log("saveOtherData")
        var mRespResumeOtherData = new RespResumeOtherData({
            companyId,
            resumeId,
            resumeKey: OtherData_education,
            resumeData: JSON.stringify(mEducationList),
        })
        //console.log(mRespResumeOtherData)
        try {
            await api_addResumeOtherData({
                mRespResumeOtherData,
                isEmployee
            })
            Swal.fire({
                type: 'success',
                title: '提醒',
                text: "儲存成功",
            })
        } catch (error) {
            console.log(error)
        }
    }


    var familyTitle = "學歷"
    var familyContent =
        <>
            {
                mEducationList.map((f, i) => (
                    <EducationItems key={"e" + i} index={i} education={f} setEducation={setEducation} isEdit={isEdit} />
                ))
            }
            {isEdit ?
                <>
                    <div className="hr-line-dashed"></div>
                    <div className="row text-right ">
                        <div className="col-sm-12">
                            <SubmitButton name={"儲存"} action={saveOtherDataFamily} isRight={true} />
                        </div>
                    </div>
                </>
                : <></>
            }
        </>


    return (
        <>
            <ContentBox title={familyTitle} content={familyContent} hasDrawer={true} />
        </>
    )
}

function EducationItems({ index, education, setEducation, isEdit }) {
    const [mEducation, setE] = useState(new RespResumeOtherDataFamilyList({}))
    const [schoolName, setSchoolName] = useState("")
    const [department, setDepartment] = useState("")
    const [during, setDuring] = useState("")
    const [status, setStatus] = useState(0)

    const placeholder = ["請填寫最高學歷", "請填寫次高學歷", "請填寫更早學歷"]
    const statusItems = [{ "val": 1, "name": "畢業" }, { "val": 2, "name": "肄業" }]

    useEffect(() => {
        if (education !== undefined && education !== mEducation) {
            setE(education)
            setSchoolName(education.schoolName)
            setDepartment(education.department)
            setDuring(education.during)
            setStatus(education.status)
        }
    }, [education])

    function setN(val) {
        setSchoolName(val)
        mEducation.schoolName = val
        setEducation(index, mEducation)
    }
    function setDe(val) {
        setDepartment(val)
        mEducation.department = val
        setEducation(index, mEducation)
    }
    function setDu(val) {
        setDuring(val)
        mEducation.during = val
        setEducation(index, mEducation)
    }
    function setS(val) {
        setStatus(val)
        mEducation.status = val
        setEducation(index, mEducation)
    }


    return (
        <>
            {index === 0 ? <></> : <div className="hr-line-dashed"></div>}
            <div className="row  m-b-sm">
                <div className="col-md-12">
                    {isEdit ?
                        <SingleInput title={"學校名稱"} val={schoolName} action={setN} placeholder={placeholder[index]} />
                        : <SingleText title={"學校名稱"} val={schoolName} />
                    }
                    {isEdit ?
                        <SingleInput title={"科系"} val={department} action={setDe} placeholder={"電機系"} />
                        : <SingleText title={"科系"} val={department} />
                    }
                    {isEdit ?
                        <SingleInput title={"就讀期間"} val={during} action={setDu} placeholder={"201109/201306"} />
                        : <SingleText title={"就讀期間"} val={during} />
                    }
                    {isEdit ?
                        <SingleRedio title={"狀態"} arr={statusItems} val={status} action={setS} />
                        : <SingleText title={"狀態"} val={getItemsInfo({ items: statusItems, val: status })} />
                    }
                </div>
            </div>
        </>
    )
}
